// Cladding
export const CLADDING_RSI = {
  brickClay102: 0.0714,
  vinylOverStrap: 0,
  vinylUnvented: 0.11,
  hardieOverStrap: 0,
  acrylicStuccoOverStrap: 0,
};

// Air spaces
// Membranes counted as 0 (kept explicit)
export const WEATHER_BARRIER_RSI = 0;
export const VAPOUR_BARRIER_RSI = 0;

// Wood path data
export const WOOD_RSIF = { '2x4': 0.757, '2x6': 1.19, '2x8': 1.56, '2x10': 2.0 };
export const AF_BY_SPACING_WOOD = { 203: 0.31, 304: 0.245, 406: 0.23, 488: 0.215, 610: 0.2 };
export const ABOVE_GRADE_CAVITY_RSI = [2.11, 2.46, 3.34, 3.52, 3.87, 3.96, 4.23, 4.93, 5.46, 6.16, 7.04];

// Steel path data (kept minimal to match your UI)
export const STEEL_RSIF = { '2x4': 4.8 / 5.67826, '2x6': 5.3 / 5.67826 };
export const AF_BY_SPACING_STEEL = { '<500': 0.235, '>=500': 0.2 };

export const SteelSpacingGroupOptions = [
  { value: '<500', label: '< 500 mm (16")' },
  { value: '>=500', label: '≥ 500 mm (24")', labelSafe: '>= 500 mm (24")' },
];

export const cavityChoicesSteel = {
  '2x4': { values: [12, 14] },
  '2x6': { values: [12, 14, 20, 22.5, 24] },
  '2x8': { values: [12, 14, 20, 22.5, 24, 28] },
  '2x10': { values: [12, 14, 20, 22.5, 24, 28, 31] },
};

export const cavityChoicesWood = {
  '2x4': { values: [12, 14] },
  '2x6': { values: [12, 14, 19, 20, 22, 24] },
  '2x8': { values: [12, 14, 19, 20, 22, 24, 28] },
  '2x10': { values: [12, 14, 19, 20, 22, 24, 28, 31] },
};

export const toRSI = {
  12: 2.11,
  14: 2.46,
  19: 3.34,
  20: 3.52,
  22: 3.87,
  22.5: 3.96,
  24: 4.23,
  28: 4.93,
  31: 5.46,
};
